<template>
    <v-container fluid class="container-head d-flex flex-column justify-center align-center cyan darken-2">
        <div :class="isMobile ? 'body-1' : ''" class="impressions-week white--text font-weight-bold text-center">{{$t('dash_overview.impressions_week', { impressionsWeek: impressionsWeek })}}</div>
        <div class="caption white--text text-center">{{$t('dash_overview.impressions_week_2')}}</div>
    </v-container>
</template>

<script>
export default {
    name: 'VisitContainer',

    props: ['impressionsWeek']

}
</script>

<style scoped>

.impressions-week {

    font-size: 45px;


}

</style>